
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': '一般',
	'widgetId': '小組件 ID',
	'widgetType': '小組件類型',
	'serviceability': '服務功能',
	'copyButton': '複製',
	'closeButton': '關閉',
	'specification': '規格',
	'viewSpecification': '檢視規格'
});
